<script lang="ts" setup>
import {
  defaultPropsArrayDate,
  type DateIntervalType as InputDateRangeDateIntervalType
} from '#components/elements/input/inputDate/inputDate.props';
import InputDateGeneric from '#components/elements/input/inputDate/inputDateGeneric/InputDateGeneric.vue';
import { useLanguage } from '#composables/useLanguage';
import dayjs from 'dayjs';
import { computed } from 'vue';

const { t } = useLanguage();

const props = defineProps(defaultPropsArrayDate);
const model = defineModel<InputDateRangeDateIntervalType>({ required: true });

const formatDateValue = (date: Date) => {
  if (date) {
    return dayjs(date).format('DD/MM/YYYY');
  }

  return '';
};

const formatedDateMin = computed(() => formatDateValue(model.value[0]));
const formatedDateMax = computed(() => formatDateValue(model.value[1]));
</script>

<template>
  <InputDateGeneric v-bind="{ ...props }" v-model="model" range multi-calendars>
    <template #content>
      <span>
        <span class="text-gray-500">{{ t(`commonLabel.from`) }}</span>
        {{ formatedDateMin }}
        <span class="text-gray-500">{{ t(`commonLabel.to`) }}</span>
        {{ formatedDateMax }}
      </span>
    </template>
  </InputDateGeneric>
</template>
